import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useAuth } from '../../state/auth'
import { TERMS_VERSION } from './TermsPage'

export function TermsAcceptancePage() {
  const { acceptTerms } = useAuth()
  const [checked, setChecked] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const onAccept = async () => {
    if (!checked) return
    setLoading(true)
    try {
      await acceptTerms(TERMS_VERSION)
      toast.success('Termos aceitos')
      navigate('/', { replace: true })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto flex min-h-screen max-w-xl items-center px-4">
        <div className="w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="text-xl font-semibold text-slate-900">Aceite obrigatório</div>
          <div className="mt-2 text-sm text-slate-600">
            Para continuar, confirme a leitura e aceite dos Termos de Uso (versão {TERMS_VERSION}).
          </div>

          <div className="mt-4 text-sm">
            <Link className="text-slate-900 underline" to="/termos" target="_blank">
              Abrir Termos de Uso
            </Link>
          </div>

          <label className="mt-6 flex items-start gap-3 text-sm text-slate-700">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>Li e aceito os Termos de Uso e a Política de Privacidade.</span>
          </label>

          <button
            className="mt-6 h-11 w-full rounded-xl bg-slate-900 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
            disabled={!checked || loading}
            onClick={onAccept}
            type="button"
          >
            {loading ? 'Confirmando…' : 'Aceitar e continuar'}
          </button>
        </div>
      </div>
    </div>
  )
}

